(function (global) {
    function logMessage(success, method, err, silent = true) {
        if (silent) return;
        console[success ? "log" : "error"](
            `${method}: ${success ? "Copying was successful" : "Could not copy text"}${err ? ` - ${err}` : ""}`
        );
    }

    function fallbackCopyTextToClipboard(text, silent = true) {
        const textArea = document.createElement("textarea");
        textArea.value = text;

        // Make textarea invisible and prevent scrolling
        Object.assign(textArea.style, {
            position: "fixed",
            opacity: "0",
        });

        document.body.appendChild(textArea);
        textArea.select();

        try {
            const successful = document.execCommand("copy");
            logMessage(successful, "Fallback", null, silent);
            return true;
        } catch (err) {
            logMessage(false, "Fallback", err, silent);
            return false;
        } finally {
            document.body.removeChild(textArea);
        }
    }

    async function copyToClipboard(text, silent = true) {
        if (!navigator.clipboard) {
            return fallbackCopyTextToClipboard(text, silent);
        }

        try {
            await navigator.clipboard.writeText(text);
            logMessage(true, "Async", null, silent);
            return true;
        } catch (err) {
            logMessage(false, "Async", err, silent);
            return fallbackCopyTextToClipboard(text, silent); // Use fallback if async fails
        }
    }

    // Make function globally accessible
    global.ClipboardUtil = {copyToClipboard};
})(window);
